var Midttrafik2016 = Midttrafik2016 || {};
Midttrafik2016.forms = Midttrafik2016.forms || {};

Midttrafik2016.forms.routeTrafficInfo = new function () {
    var self = this;

    this.init = function() {
    };

    this.loadTrafficInfo = function(obj) {
        var routeNumber = obj.attr('routeNumber');
        var nodeId = obj.attr('nodeId');
        var formData = 'RouteNumber=' + routeNumber + '&RouteNodeId=' + nodeId;

        $.ajax({
            type: 'POST',
            url: '/umbraco/Surface/RouteTrafficInfo/SearchTrafficInfo',
            data: formData,
            dataType: 'html',
            success: function(data) {
                $('#target-trafficdetails-' + nodeId).html(data);
            },
            complete: function() {
                determineLinesShown();
            }
        });
    };
} ();
